export default __webpack_public_path__ + "static/media/IMG_0422-2.d4bb9b5e.jpg";